@if (visible()) {
    <div class="labs" (click)="$event.stopPropagation()">
        <button
            type="button"
            class="labs__chip"
            [class.labs__chip--open]="open()"
            [class.labs__chip--static]="!desplegable()"
            [attr.aria-expanded]="desplegable() ? open() : null"
            [title]="desplegable() ? 'Ver los laboratorios asignados' : resumen()"
            (click)="toggle()">
            <tui-icon class="labs__icon" icon="@tui.flask-conical" />
            <span class="labs__text">{{ resumen() }}</span>
            @if (desplegable()) {
                <tui-icon
                    class="labs__caret"
                    [class.labs__caret--open]="open()"
                    icon="@tui.chevron-down" />
            }
        </button>

        @if (open()) {
            <div class="labs__panel">
                <p class="labs__panel-title">Laboratorios asignados</p>
                <ul class="labs__list">
                    @for (lab of listado(); track lab.type + lab.itmsGrpCod) {
                        <li class="labs__item">
                            <span class="labs__dot"></span>
                            <span class="labs__name">{{ lab.itmsGrpNam || lab.itmsGrpCod }}</span>
                            <span class="labs__source">{{ lab.type === 'Sap' ? 'SAP' : 'Korber' }}</span>
                        </li>
                    }
                </ul>
                <p class="labs__footer">{{ total() }} en total</p>
            </div>
        }
    </div>
}
